import { VrcExperience } from "~/types/plan";

export type CartConfigAddressCheck = {
  title?: {
    copy?: string;
  };
  subtitle?: {
    copy?: string;
    enabled?: string;
    icon?: string;
  };
  addressCheckDisclaimer?: string;
  headingLevel?: string;
  placeholder?: string;
  verifyPhoneEnabled?: string; // TODO change this into a string
  vrcExperience?: VrcExperience;
  resumeModal?: {
    heading?: {
      copy?: string;
    };
    subheading?: {
      copy?: string;
    };
    button?: {
      copy?: string;
    };
    tooltip?: {
      copy?: string;
    };
    badge?: {
      copy?: string;
      icon?: string;
      backgroundColor?: string;
      borderColor?: string;
      iconColor?: string;
      copyColor?: string;
    };
  };
  offerPlacement?: {
    enabled?: boolean;
    title?: string;
    tiles?: {
      heading?: string;
      copy?: string;
      icon?: string;
    }[];
  };
  buyFlow?: string;
};

export const cartConfigAddressCheckDefaultValue: CartConfigAddressCheck = {
  title: {
    copy: "Enter your address to view plans and exclusive offers.",
  },
  subtitle: {
    copy: "You may be eligible for special offers, like free installation and a Wi-Fi router included in your plan.",
    enabled: "true",
    icon: "star",
  },
  addressCheckDisclaimer: "Frontier<sup>&reg;</sup> Fiber Internet available in select areas.",
  headingLevel: "1",
  placeholder: "Enter your address",
  verifyPhoneEnabled: "false",
  resumeModal: {
    heading: {
      copy: "Welcome back. Let's finish your order.",
    },
    subheading: {
      copy: "Welcome back. Let's finish your order.",
    },
    button: {
      copy: "CONTINUE CHECKOUT",
    },
    tooltip: undefined,
  },
  vrcExperience: {
    vrcPassbackEnabled: false,
    vrcExperienceModalEnabled: false,
    vrcExperienceExitIntentEnabled: false,
    vrcExperienceModalDelay: 30000,
    vrcExperienceModalHeadline: "Don't miss this exclusive online only offer!",
    vrcExperienceModalSubheadline: "Order Fiber 1 Gig today, get a $100 Visa® Reward Card. Online only.",
    vrcExperienceModalTooltip:
      "You will receive an email including the $100 Visa® Reward Card details within 24 hours of your online submitted order. One-year agreement, other terms and redemption requirements apply.",
    vrcExperienceModalCta: "Get 1 gig",
    vrcExperienceYttv: {
      enabled: false,
      showAllPromoBanner: true,
      value: 50,
    },
    vrcExperienceReturnVisitorLtoEnabled: false,
    vrcExperiencePlanSpeeds: {
      "200": false,
      "500": false,
      "1000": false,
      "2000": false,
      "5000": false,
      "7000": false,
    },
  },
  offerPlacement: {
    enabled: false,
    title: "Get more than just great internet. Join Frontier and get access to these special deals.",
    tiles: [
      {
        heading: "Unlock top Wi-Fi 7 tech",
        copy: "Now, get the best Wi-Fi ever, Wi-Fi 7, free on more fiber plans.",
        icon: "router",
      },
      {
        heading: "Get one month of Whole-Home Wi-Fi on us",
        copy: "Supercharge your Wi-Fi coverage throughout your home. Only $10/mo. after your first month.",
        icon: "wholeHomeWifi",
      },
      {
        heading: "Free installation included",
        copy: "Fast, easy setup to get up and running quickly.",
        icon: "wrench",
      },
    ],
  },
};
